import React, { useState } from "react";
import Step from "components/MainApp/atoms/Wizard/Step";
import Icon from "components/MainApp/atoms/Icon/icon";
import ProductSummaryItem from "components/MainApp/organisms/Orders/RequestOrders/ProductSummaryItem";
import { isMobile } from 'helpers/Mobile';
import TwoOptionModal from "components/MainApp/atoms/Modals/TwoOptionModal";
import batchIcon from "assets/images/batch-icon.svg";
import expireIcon from "assets/images/expire-icon.svg";
import downloadIcon from "assets/images/download-icon.svg";
import editIcon from "assets/images/edit-icon.svg";
import arrowIcon from "assets/images/arrow-icon.svg";
import defaultImage from "assets/images/default_product.png";

import styles from "./Step2.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

export const AddConfigTagStepTwo = ({tag,
  addedProducts,
  handleEdit,
  handleContinue,
  enableContinue,
  error,
  handleClose,
  handlePersist,
  modalPersistOpen,
  onlyCloseModal,
  handleFinishStepTwo,
  handleDownloadTags}
) => {

    const [openConfirmModal, setOpenConfirmModal] = useState(false);

    const handleConfirm = () => {
        let data = '';
        handlePersist()
    }
    const handleCloseIntern = () => {
        handleClose();
    }

    const handleCloseIcon = () => {
      onlyCloseModal();
    }

    const handleFinish = () => {
      setOpenConfirmModal(true);
    }

    const handleConfirmModal = () => {
      handleFinishStepTwo();
    }

    const handleCloseIconConfirm = () => {
      setOpenConfirmModal(false);
    }

    const mwidth = isMobile ? '100% ': '322px';
    const modalContent = '';

    const stepContent = (
      <div className={styles["add-tag-wizard-step-two-content"]}>
        <header>
          <div className={styles["verify-data-title"]}>
            <div>
              <button onClick={handleEdit}>
                <img src={arrowIcon} draggable={false} />
              </button>
              <h4>{i18n.t("check.data")}</h4>
            </div>
            <nav>
              <button onClick={handleEdit}>
                <img src={editIcon} draggable={false} />
              </button>
              <button onClick={handleDownloadTags}>
                <img src={downloadIcon} draggable={false} />
              </button>
            </nav>
          </div>
          <div className={styles["verify-data-info"]}>
            <div className={styles["verify-data-info__item"]}>
              <picture>
                <img src={batchIcon} draggable={false} />
              </picture>
              <p>{i18n.t("batch")} <span>{tag.batch}</span></p>
            </div>
            <div className={styles["verify-data-info__item"]}>
              <picture>
                <img src={expireIcon} draggable={false} />
              </picture>
              <p>{i18n.t("expiration.date")} <span>{tag.due_date}</span></p>
            </div>
          </div>
        </header>

        <div className={styles["info-group"]}>
          {addedProducts.map((item, i) => {
            return (
              <article key={i} className={styles["item-tags-group"]}>
                <section className={styles["item-tags-group-product"]}>
                  <div className={styles["item-tags-group-product-info"]}>
                    <img src={item?.image || defaultImage} draggable={false} />
                    <div>
                      <h4>{item.name}</h4>
                      <p>SKU {item.sku}</p>
                    </div>
                  </div>
                  <span>{item.tags.length} {i18n.t("tags")}</span>
                </section>
                <section className={styles["item-tags-group-tags"]}>
                  {item.tags.map((tag, i) => {
                    return <p className={styles["tag"]} key={i}>{tag.rfid}</p>
                  })}
                </section>
              </article>
            );
          })}
        </div>

        <div className={styles["add-tag-wizard-step-two-action-wrapper"]}>
          <button
            className={`${styles["add-tag-wizard-step-two-action-button"]} ${!enableContinue &&
              styles["disabled"]} ${styles["finish"]}`}
            onClick={handleFinish}
          >
            {i18n.t("finish").toUpperCase()}
          </button>

          <button
            type="submit"
            className={`${styles["add-tag-wizard-step-two-action-button"]} ${!enableContinue &&
              styles["disabled"]}`}
            onClick={enableContinue ? handleContinue : undefined}
          >
            {i18n.t("continue").toUpperCase()}
          </button>
        </div>
      </div>
    );

    return (
      <div className={styles["add-tag-wizard-step-two-container"]}>
        <Step
          className={styles["custom-step"]}
          title={i18n.t("check.data")}
          content={stepContent}
          hideTitle={true}
        ></Step>
        <TwoOptionModal
          open={modalPersistOpen}
          title={i18n.t("interrupt.tags.printing")}
          subtitle={
            <span style={{ fontFamily: "Ubuntu-Medium", color: "#676F8F" }}>
              {i18n.t("exit.and.save.question")}
            </span>
          }
          closeLabel={i18n.t("exit.without.saving").toUpperCase()}
          confirmLabel={i18n.t("save").toUpperCase()}
          handleClose={handleCloseIntern}
          handleConfirm={handleConfirm}
          modalContent={modalContent}
          confirmDisabled={false}
          closeable={true}
          handleCloseIcon={handleCloseIcon}
        ></TwoOptionModal>

        <TwoOptionModal
          open={openConfirmModal}
          title={i18n.t("process.finish")}
          subtitle={
            <span style={{ fontFamily: "Ubuntu-Medium", color: "#676F8F" }}>
              {i18n.t("exit.and.cancel.question")}
            </span>
          }
          closeLabel={i18n.t("cancel").toUpperCase()}
          handleClose={handleCloseIconConfirm}
          confirmLabel={i18n.t("save").toUpperCase()}
          handleConfirm={handleConfirmModal}
          modalContent={modalContent}
          confirmDisabled={false}
        />
      </div>
    );
  }

export default AddConfigTagStepTwo;
